import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { errorMessages } from "@/lib/constants";
import { addPaymentInstrument } from "@/lib/mailTemplate";
import sendEmail from "@/lib/sendEmail";
import { gql } from "@apollo/client";
import { composeResolvers } from "@graphql-tools/resolvers-composition";
import crypto from "crypto";
import jwt from "jsonwebtoken";
import { isAuthenticated, ownerOnly } from "./helper";
import config from "@/lib/config";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type PaymentInstruments @cacheControl(scope: PRIVATE, maxAge: 0) {\n    default_flag: Boolean\n    payment_method: PaymentMethod\n    payment_method_id: Int\n    payment_instrument_id: Int\n    ref_id: String\n    values: PurchaseMethodsValues\n  }\n\n  type PurchaseMethodsValues {\n    card_number: String\n    card_type: String\n    expiry_date: String\n  }\n  type PaymentMethod {\n    name: String\n  }\n\n  type PaymentInstrumentsCreateCreditCardRecaptchaV2Result\n    @cacheControl(scope: PRIVATE) {\n    payment_instrument_id: Int\n    payment_method_id: Int\n    status: String\n    error: String\n    recaptchaSuccessV2: Boolean\n  }\n\n  type PaymentInstrumentsCreateCreditCardRecaptchaV3Result\n    @cacheControl(scope: PRIVATE) {\n    payment_instrument_id: Int\n    payment_method_id: Int\n    status: String\n    error: String\n    recaptchaSuccessV3: Boolean\n  }\n\n  type PaymentInstrumentsCreateOther @cacheControl(scope: PRIVATE) {\n    redirect_link: Boolean\n    http_method: String\n    redirect_url: String\n    form_data: FormData\n    charset: String\n    error: String\n  }\n\n  type FormData {\n    pay_method: String\n    merchant_id: String\n    service_id: String\n    cust_code: Int\n    order_id: String\n    item_id: String\n    item_name: String\n    service_type: Int\n    terminal_type: Int\n    success_url: String\n    cancel_url: String\n    error_url: String\n    pagecon_url: String\n    free1: String\n    free2: String\n    free3: String\n    request_date: String\n    limit_second: String\n    sps_hashcode: String\n  }\n\n  type PaymentInstrumentsDeactivate @cacheControl(scope: PRIVATE) {\n    payment_instrument_id: Int\n    error: PaymentInstrumentsDeactivateError\n  }\n\n  type PaymentInstrumentsDeactivateError @cacheControl(scope: PRIVATE) {\n    message: String\n  }\n\n  type PaymentInstrumentsSetDefault @cacheControl(scope: PRIVATE) {\n    default_flag: Boolean\n  }\n\n  type SendMailResult {\n    result: Boolean\n  }\n\n  type Query {\n    paymentInstruments(type: String): [PaymentInstruments]\n    paymentInstrumentInfo(id: Int): PaymentInstruments\n  }\n\n  type Mutation {\n    paymentInstrumentsCreateCreditCardRecaptchaV2(\n      payment_method_id: Int\n      replace_flag: Boolean\n      token: String\n      token_key: String\n      recaptchaTokenV2: String\n    ): PaymentInstrumentsCreateCreditCardRecaptchaV2Result\n\n    paymentInstrumentsCreateCreditCardRecaptchaV3(\n      payment_method_id: Int\n      replace_flag: Boolean\n      token: String\n      token_key: String\n      recaptchaTokenV3: String\n    ): PaymentInstrumentsCreateCreditCardRecaptchaV3Result\n\n    paymentInstrumentsCreateOther(\n      payment_method_id: Int\n      replace_flag: Boolean\n      success_url: String\n      cancel_url: String\n      error_url: String\n      tokenPayload: JSONObject\n    ): PaymentInstrumentsCreateOther\n\n    paymentInstrumentsDeactivate(\n      payment_instrument_id: Int\n    ): PaymentInstrumentsDeactivate\n\n    paymentInstrumentsSetDefault(\n      payment_instrument_id: Int\n    ): PaymentInstrumentsSetDefault\n\n    addPaymentInstrumentSendMail(paymentInstrumentId: Int): SendMailResult\n  }\n"])));
export var resolvers = composeResolvers({
  Query: {
    paymentInstruments: function () {
      var _paymentInstruments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, args, _ref) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataSources = _ref.dataSources;
                _context.prev = 1;
                _context.next = 4;
                return dataSources.paymentInstruments.getPaymentInstruments(args);

              case 4:
                res = _context.sent;
                return _context.abrupt("return", res.payment_instruments);

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                console.log("getPaymentInstruments error", _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }));

      function paymentInstruments(_x, _x2, _x3) {
        return _paymentInstruments.apply(this, arguments);
      }

      return paymentInstruments;
    }(),
    paymentInstrumentInfo: function () {
      var _paymentInstrumentInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, _ref2, _ref3) {
        var id, dataSources, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = _ref2.id;
                dataSources = _ref3.dataSources;
                _context2.prev = 2;
                _context2.next = 5;
                return dataSources.paymentInstruments.paymentInstrument(id);

              case 5:
                res = _context2.sent;
                return _context2.abrupt("return", res.payment_instrument);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);
                console.log(_context2.t0);
                return _context2.abrupt("return", null);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 9]]);
      }));

      function paymentInstrumentInfo(_x4, _x5, _x6) {
        return _paymentInstrumentInfo.apply(this, arguments);
      }

      return paymentInstrumentInfo;
    }()
  },
  Mutation: {
    paymentInstrumentsCreateCreditCardRecaptchaV2: function () {
      var _paymentInstrumentsCreateCreditCardRecaptchaV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_parent, args, _ref4) {
        var req, dataSources, recaptchaSuccess, recaptchaResult, _yield$dataSources$pa, paymentInstrument, _yield$dataSources$us, user, message;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                req = _ref4.req, dataSources = _ref4.dataSources;
                recaptchaSuccess = false;
                _context3.prev = 2;
                console.log("########## paymentInstrumentsCreateCreditCardV2 ##########");
                _context3.next = 6;
                return dataSources.recaptcha.recaptchaVerifyV2(args === null || args === void 0 ? void 0 : args.recaptchaTokenV2);

              case 6:
                recaptchaResult = _context3.sent;
                recaptchaSuccess = (recaptchaResult === null || recaptchaResult === void 0 ? void 0 : recaptchaResult.success) || false;

                if (recaptchaSuccess) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return", {
                  error: errorMessages["recaptcha"],
                  recaptchaSuccessV2: recaptchaSuccess
                });

              case 10:
                if (!recaptchaSuccess) {
                  _context3.next = 24;
                  break;
                }

                _context3.next = 13;
                return dataSources.paymentInstruments.paymentInstrumentsCreateCreditCard(args);

              case 13:
                _yield$dataSources$pa = _context3.sent;
                paymentInstrument = _yield$dataSources$pa.payment_instrument;
                console.log("paymentInstrumentsCreateCreditCardV2", paymentInstrument);
                console.log("########## paymentInstrumentsCreateCreditCardV2 END ##########"); // メール送信

                _context3.next = 19;
                return dataSources.user.me();

              case 19:
                _yield$dataSources$us = _context3.sent;
                user = _yield$dataSources$us.user;
                _context3.next = 23;
                return sendEmail(addPaymentInstrument({
                  address: user.mail_address,
                  paymentInstrument: paymentInstrument.payment_instrument
                }, req.adultMode));

              case 23:
                return _context3.abrupt("return", _objectSpread(_objectSpread({}, paymentInstrument.payment_instrument), {}, {
                  recaptchaSuccessV2: recaptchaSuccess
                }));

              case 24:
                _context3.next = 31;
                break;

              case 26:
                _context3.prev = 26;
                _context3.t0 = _context3["catch"](2);
                console.log("PaymentInstrumentsCreateCreditCardV2 error", _context3.t0);
                message = errorMessages["paymentRegister"];
                return _context3.abrupt("return", {
                  error: message,
                  recaptchaSuccessV2: recaptchaSuccess
                });

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 26]]);
      }));

      function paymentInstrumentsCreateCreditCardRecaptchaV2(_x7, _x8, _x9) {
        return _paymentInstrumentsCreateCreditCardRecaptchaV.apply(this, arguments);
      }

      return paymentInstrumentsCreateCreditCardRecaptchaV2;
    }(),
    paymentInstrumentsCreateCreditCardRecaptchaV3: function () {
      var _paymentInstrumentsCreateCreditCardRecaptchaV2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_parent, args, _ref5) {
        var req, dataSources, recaptchaSuccess, recaptchaResult, _yield$dataSources$pa2, paymentInstrument, _yield$dataSources$us2, user, message;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                req = _ref5.req, dataSources = _ref5.dataSources;
                recaptchaSuccess = false;
                _context4.prev = 2;
                console.log("########## paymentInstrumentsCreateCreditCardV3 ##########");
                _context4.next = 6;
                return dataSources.recaptcha.recaptchaVerifyV3(args === null || args === void 0 ? void 0 : args.recaptchaTokenV3);

              case 6:
                recaptchaResult = _context4.sent;
                recaptchaSuccess = (recaptchaResult === null || recaptchaResult === void 0 ? void 0 : recaptchaResult.score) >= config.reCAPTCHAThresholdV3 || false;

                if (recaptchaSuccess) {
                  _context4.next = 10;
                  break;
                }

                return _context4.abrupt("return", {
                  error: errorMessages["recaptcha"],
                  recaptchaSuccessV3: recaptchaSuccess
                });

              case 10:
                if (!recaptchaSuccess) {
                  _context4.next = 24;
                  break;
                }

                _context4.next = 13;
                return dataSources.paymentInstruments.paymentInstrumentsCreateCreditCard(args);

              case 13:
                _yield$dataSources$pa2 = _context4.sent;
                paymentInstrument = _yield$dataSources$pa2.payment_instrument;
                console.log("paymentInstrumentsCreateCreditCardV3", paymentInstrument);
                console.log("########## paymentInstrumentsCreateCreditCardV3 END ##########");
                _context4.next = 19;
                return dataSources.user.me();

              case 19:
                _yield$dataSources$us2 = _context4.sent;
                user = _yield$dataSources$us2.user;
                _context4.next = 23;
                return sendEmail(addPaymentInstrument({
                  address: user.mail_address,
                  paymentInstrument: paymentInstrument.payment_instrument
                }, req.adultMode));

              case 23:
                return _context4.abrupt("return", _objectSpread(_objectSpread({}, paymentInstrument.payment_instrument), {}, {
                  recaptchaSuccessV3: recaptchaSuccess
                }));

              case 24:
                _context4.next = 31;
                break;

              case 26:
                _context4.prev = 26;
                _context4.t0 = _context4["catch"](2);
                console.log("PaymentInstrumentsCreateCreditCardV3 error", _context4.t0);
                message = errorMessages["paymentRegister"];
                return _context4.abrupt("return", {
                  error: message,
                  recaptchaSuccessV3: recaptchaSuccess
                });

              case 31:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 26]]);
      }));

      function paymentInstrumentsCreateCreditCardRecaptchaV3(_x10, _x11, _x12) {
        return _paymentInstrumentsCreateCreditCardRecaptchaV2.apply(this, arguments);
      }

      return paymentInstrumentsCreateCreditCardRecaptchaV3;
    }(),
    paymentInstrumentsCreateOther: function () {
      var _paymentInstrumentsCreateOther = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_parent, _ref6, _ref7) {
        var payment_method_id, replace_flag, success_url, cancel_url, error_url, tokenPayload, req, dataSources, secret, token, res, message;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                payment_method_id = _ref6.payment_method_id, replace_flag = _ref6.replace_flag, success_url = _ref6.success_url, cancel_url = _ref6.cancel_url, error_url = _ref6.error_url, tokenPayload = _ref6.tokenPayload;
                req = _ref7.req, dataSources = _ref7.dataSources;
                _context5.prev = 2;
                console.log("########## paymentInstrumentsCreateOther ##########");
                console.log("params", {
                  payment_method_id: payment_method_id,
                  replace_flag: replace_flag,
                  success_url: success_url,
                  cancel_url: cancel_url,
                  error_url: error_url,
                  tokenPayload: tokenPayload
                });
                secret = crypto.createHash("sha256").update("payment:".concat(req.userToken.id)).digest("hex");
                token = jwt.sign(tokenPayload, secret);
                success_url = "".concat(success_url, "?token=").concat(token);
                _context5.next = 10;
                return dataSources.paymentInstruments.paymentInstrumentsCreateOther(payment_method_id, replace_flag, success_url, cancel_url, error_url);

              case 10:
                res = _context5.sent;
                console.log("paymentInstrumentsCreateOther", res);
                console.log("########## paymentInstrumentsCreateOther END ##########");
                return _context5.abrupt("return", res);

              case 16:
                _context5.prev = 16;
                _context5.t0 = _context5["catch"](2);
                console.log("PaymentInstrumentsCreateOther error", _context5.t0);
                message = errorMessages["paymentRegister"];
                return _context5.abrupt("return", {
                  error: message
                });

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 16]]);
      }));

      function paymentInstrumentsCreateOther(_x13, _x14, _x15) {
        return _paymentInstrumentsCreateOther.apply(this, arguments);
      }

      return paymentInstrumentsCreateOther;
    }(),
    paymentInstrumentsDeactivate: function () {
      var _paymentInstrumentsDeactivate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_parent, args, _ref8) {
        var dataSources, res, _e$extensions, _e$extensions$respons, _e$extensions$respons2, _e$extensions$respons3, message;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                dataSources = _ref8.dataSources;
                _context6.prev = 1;
                _context6.next = 4;
                return dataSources.paymentInstruments.paymentInstrumentsDeactivate(args);

              case 4:
                res = _context6.sent;
                return _context6.abrupt("return", res.payment_instrument);

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](1);
                console.log("paymentInstrumentsDeactivate error");
                message = _context6.t0 === null || _context6.t0 === void 0 ? void 0 : (_e$extensions = _context6.t0.extensions) === null || _e$extensions === void 0 ? void 0 : (_e$extensions$respons = _e$extensions.response) === null || _e$extensions$respons === void 0 ? void 0 : (_e$extensions$respons2 = _e$extensions$respons.body) === null || _e$extensions$respons2 === void 0 ? void 0 : (_e$extensions$respons3 = _e$extensions$respons2.error) === null || _e$extensions$respons3 === void 0 ? void 0 : _e$extensions$respons3.message;
                return _context6.abrupt("return", {
                  error: {
                    message: message
                  }
                });

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[1, 8]]);
      }));

      function paymentInstrumentsDeactivate(_x16, _x17, _x18) {
        return _paymentInstrumentsDeactivate.apply(this, arguments);
      }

      return paymentInstrumentsDeactivate;
    }(),
    paymentInstrumentsSetDefault: function () {
      var _paymentInstrumentsSetDefault = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_parent, args, _ref9) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                dataSources = _ref9.dataSources;
                _context7.prev = 1;
                _context7.next = 4;
                return dataSources.paymentInstruments.paymentInstrumentsSetDefault(args);

              case 4:
                res = _context7.sent;
                return _context7.abrupt("return", res);

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](1);
                console.log("paymentInstrumentsSetDefault error", _context7.t0);

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[1, 8]]);
      }));

      function paymentInstrumentsSetDefault(_x19, _x20, _x21) {
        return _paymentInstrumentsSetDefault.apply(this, arguments);
      }

      return paymentInstrumentsSetDefault;
    }(),
    addPaymentInstrumentSendMail: function () {
      var _addPaymentInstrumentSendMail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_parent, _ref10, _ref11) {
        var paymentInstrumentId, req, dataSources, _yield$dataSources$pa3, paymentInstrument, _yield$dataSources$us3, user;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                paymentInstrumentId = _ref10.paymentInstrumentId;
                req = _ref11.req, dataSources = _ref11.dataSources;
                _context8.prev = 2;
                _context8.next = 5;
                return dataSources.paymentInstruments.paymentInstrument(paymentInstrumentId);

              case 5:
                _yield$dataSources$pa3 = _context8.sent;
                paymentInstrument = _yield$dataSources$pa3.payment_instrument;
                _context8.next = 9;
                return dataSources.user.me();

              case 9:
                _yield$dataSources$us3 = _context8.sent;
                user = _yield$dataSources$us3.user;
                _context8.next = 13;
                return sendEmail(addPaymentInstrument({
                  address: user.mail_address,
                  paymentInstrument: paymentInstrument
                }, req.adultMode));

              case 13:
                return _context8.abrupt("return", {
                  result: true
                });

              case 16:
                _context8.prev = 16;
                _context8.t0 = _context8["catch"](2);
                console.log("add paymentInstrument sendEmail error", _context8.t0);
                return _context8.abrupt("return", {
                  result: false
                });

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[2, 16]]);
      }));

      function addPaymentInstrumentSendMail(_x22, _x23, _x24) {
        return _addPaymentInstrumentSendMail.apply(this, arguments);
      }

      return addPaymentInstrumentSendMail;
    }()
  }
}, {
  "Mutation.paymentInstrumentsCreateCreditCardRecaptchaV2": [isAuthenticated(), ownerOnly()],
  "Mutation.paymentInstrumentsCreateCreditCardRecaptchaV3": [isAuthenticated(), ownerOnly()],
  "Mutation.paymentInstrumentsCreateOther": [isAuthenticated(), ownerOnly()],
  "Mutation.paymentInstrumentsDeactivate": [isAuthenticated(), ownerOnly()],
  "Mutation.paymentInstrumentsSetDefault": [isAuthenticated(), ownerOnly()]
});